module.exports = __webpack_public_path__ + "img/NF03-1.42ef7def.png";